import omitDeep from 'omit-deep-lodash';

export const cleanDataFromTypes = (data) => omitDeep(data, '__typename');
